// Local mirror of the cloud's PatternAnalyzerNode + ThinkingGuideNode chain,
// combined into ONE call (not two) — the local model is already slower than
// cloud Gemini, so one combined generation avoids doubling per-turn latency.
// Returns {patterns, next_moves, questions} directly: this shape carries no
// cards-on-board/session-memory concept, so it bypasses finalizeMentorParsed
// entirely (same statelessness as the cloud leaf it mirrors).
import { extractAndParseJSON } from "./jsonRepair";
import { render, renderStr, vocab } from "./prompts";

export function buildBrainstormMessages({ purpose, usedCards = [], unusedCards = [], knowledge = "", lang = "it" }) {
  const v = vocab(lang);
  const usedLabels = usedCards.map((c) => c.label);

  const system = render("brainstorm_system", lang);

  const user = renderStr("brainstorm", lang, {
    purpose: purpose || v.not_defined_yet,
    cards: JSON.stringify(usedLabels),
    knowledge: knowledge || v.no_context_retrieved,
  });

  return {
    messages: [
      { role: "system", content: system },
      { role: "user", content: user },
    ],
  };
}

export function parseBrainstormJSON(raw) {
  const toStringArray = (v) => (Array.isArray(v) ? v.filter((x) => typeof x === "string") : []);
  const obj = extractAndParseJSON(raw);
  if (obj) {
    return {
      patterns: toStringArray(obj.patterns),
      next_moves: toStringArray(obj.next_moves),
      questions: toStringArray(obj.questions),
    };
  }
  return { patterns: [], next_moves: [], questions: [] };
}
